import { action } from 'satcheljs';

export interface Win32StyleEnabledChangedActionMessage {
    isEnabled: boolean;
}

const onWin32StyleEnabledChanged: (isEnabled: boolean) => Win32StyleEnabledChangedActionMessage =
    action(
        'onWin32StyleEnabledChanged',
        (isEnabled: boolean): Win32StyleEnabledChangedActionMessage => ({
            isEnabled,
        })
    );

export default onWin32StyleEnabledChanged;
